import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// An oversized incandescent light bulb as an icon prop: a pale glass envelope, a
// hint of filament inside, a neck and a brass screw base on a small foot so it
// stands. The universal symbol of electric light.
const GLASS = "#f4efc8";
const GLASS_DK = "#e0d9a8";
const BRASS = "#c9a23f";
const BRASS_DK = "#9c7c2c";
const FILAMENT = "#ffcf6a";

export const lightBulb = defineModel({
  id: "light-bulb",
  batchId: "electric",
  name: "Light bulb",
  tags: ["prop", "electric", "power", "lighting", "bulb"],
  summary: "An oversized incandescent bulb with a brass screw base.",
  footprint: 0.25,
  parts(): Part[] {
    return [
      // Small foot so it stands.
      { geometry: new THREE.CylinderGeometry(0.12, 0.14, 0.04, 12), color: "#5a5a5e", position: [0, 0.02, 0] },
      // Brass screw base with thread rings.
      { geometry: new THREE.CylinderGeometry(0.1, 0.1, 0.14, 12), color: BRASS, position: [0, 0.11, 0] },
      { geometry: new THREE.CylinderGeometry(0.105, 0.105, 0.02, 12), color: BRASS_DK, position: [0, 0.09, 0] },
      { geometry: new THREE.CylinderGeometry(0.105, 0.105, 0.02, 12), color: BRASS_DK, position: [0, 0.13, 0] },
      { geometry: new THREE.CylinderGeometry(0.05, 0.1, 0.05, 12), color: BRASS_DK, position: [0, 0.05, 0] },
      // Neck and glass envelope.
      { geometry: new THREE.CylinderGeometry(0.16, 0.1, 0.12, 12), color: GLASS, position: [0, 0.24, 0] },
      { geometry: new THREE.SphereGeometry(0.2, 14, 12), color: GLASS, position: [0, 0.42, 0], scale: [1, 1.05, 1] },
      { geometry: new THREE.SphereGeometry(0.18, 10, 8), color: GLASS_DK, position: [0, 0.42, -0.04], scale: [1, 1.05, 1] },
      // Filament hint inside.
      { geometry: new THREE.BoxGeometry(0.02, 0.12, 0.02), color: FILAMENT, position: [-0.03, 0.4, 0.1] },
      { geometry: new THREE.BoxGeometry(0.02, 0.12, 0.02), color: FILAMENT, position: [0.03, 0.4, 0.1] },
      { geometry: new THREE.BoxGeometry(0.06, 0.02, 0.02), color: FILAMENT, position: [0, 0.46, 0.1] },
    ];
  },
  animations: [],
});
